import { ICreatorsItems, INichesItems, ITagsList } from "@/common/api/services/types";
import { SearchResults } from "../SearchResults";
import Skeleton from "@/common/images/icons/search-skeleton.svg?react";
import { searchTabsEnum } from "../Tabs";
import { MoreResultsLink } from "../MoreResultsLink";
import "./CategoryResults.scss";

interface ICategoryResults {
  searchValue: string;
  data: ICreatorsItems[] | INichesItems[] | ITagsList[];
  title?: string;
  loading?: boolean;
  activeTab: Exclude<searchTabsEnum, searchTabsEnum.ALL>;
}

export const CategoryResults = ({
  searchValue,
  data,
  loading,
  title,
  activeTab
}: ICategoryResults) => {
  if (loading) {
    return <Skeleton />;
  }

  return (
    <div className="categoryResults">
      <SearchResults searchValue={searchValue} data={data} title={title} activeTab={activeTab} />
      {!!data.length && <MoreResultsLink activeTab={activeTab} searchValue={searchValue} />}
    </div>
  );
};
